import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { RoleView } from "./RoleView";
import { RoleViewStore } from "../../store/RoleViewStore";
import { useStore } from "../../../../hooks";

export const RoleViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/role/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new RoleViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <RoleView roleViewStore={store} />
      </PageLayout>
    </div>
  );
});
